var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5328 0.00195312H6.46319C2.89163 0.00195312 0 2.89358 0 6.46514V25.5388C0 29.1063 2.89163 31.998 6.46319 31.998H25.5368C29.1044 31.998 32 29.1063 32 25.5348V6.46514C31.996 2.89358 29.1044 0.00195312 25.5328 0.00195312Z",
    fill: "url(#paint0_linear_406_292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.862 7.35321L16.5099 6.23334C16.9099 5.5334 17.8017 5.29746 18.5017 5.6974C19.2016 6.09734 19.4376 6.98921 19.0376 7.68915L12.7944 18.4958H17.3098C18.7736 18.4958 19.5935 20.2156 18.9576 21.4075H5.7193C4.91143 21.4075 4.26349 20.7595 4.26349 19.9516C4.26349 19.1438 4.91143 18.4958 5.7193 18.4958H9.43086L14.1823 10.2608L12.6985 7.68515C12.2986 6.98521 12.5345 6.10134 13.2344 5.6934C13.9344 5.29346 14.8182 5.5294 15.2262 6.22934L15.862 7.35321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2468 22.9072L8.84694 25.3349C8.447 26.0349 7.55513 26.2708 6.85519 25.8709C6.15525 25.4709 5.91932 24.579 6.31925 23.8791L7.35913 22.0794C8.53494 21.7154 9.49082 21.9954 10.2468 22.9072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3012 18.504H26.0887C26.8966 18.504 27.5445 19.152 27.5445 19.9598C27.5445 20.7677 26.8966 21.4156 26.0887 21.4156H23.9849L25.4048 23.8793C25.8047 24.5793 25.5688 25.4631 24.8688 25.8711C24.1689 26.271 23.285 26.0351 22.8771 25.3351C20.4854 21.1876 18.6896 18.0841 17.4978 16.0163C16.2779 13.9126 17.1498 11.8008 18.0097 11.085C18.9656 12.7248 20.3934 15.2005 22.3012 18.504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_292",
    x1: 16,
    y1: 0.00195313,
    x2: 16,
    y2: 31.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e7f0b1b5b243926757e066763971db40.svg";
export { ForwardRef as ReactComponent };